import styled from 'styled-components';

import { StyleColor } from '../../../../utils/styles-constants';

const StyledButtonRemove = styled('button')`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background-color: ${StyleColor.Grey100};
	outline: 0;
	cursor: pointer;

	svg {
		width: 7px;
		height: 7px;
		fill: ${StyleColor.Grey450};
	}
`;

export { StyledButtonRemove };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ButtonRemove/styles.ts